import { getStoreBuilder } from 'vuex-typex';
import { RootState } from '..';

export type Player = {
    id: string,
    name: string
}

export type PlayerId = string;

export type JustoneGameState = {
    gid: string,
    isOwner: boolean,
    playerInfo: Player,
    players: Player[],
    currentTurn: {
        turn: number,
        currentPlayerId: PlayerId,
        word: string | undefined,
        hints: {
            [pid: string]: string
        },
        playersWhoAddedHints: PlayerId[]
    }
};

const initialState: JustoneGameState = {
    gid: "",
    isOwner: false,
    playerInfo: {} as Player,
    players: [],
    currentTurn: {
        turn: -1,
        currentPlayerId: "",
        word: "",
        hints: {},
        playersWhoAddedHints: []
    }
}

export const builder = getStoreBuilder<RootState>().module("game", initialState);